import { Component, OnInit } from '@angular/core';

import $ from 'jquery';
import { MdDialogRef } from '@angular/material';
import platform from 'platform';

@Component({
  selector: 'act-dialog-map',
  templateUrl: './dialog-map.component.html',
  styleUrls: ['./dialog-map.component.scss']
})
export class DialogMapComponent implements OnInit {

  public lat: Number;
  public lng: Number;
  public title: String;
  public rating: Number;
  public address: String;

  $mapElement: any;

  constructor(public dialogRef: MdDialogRef<any>) { }

  ngOnInit() {}

  public resetIphoneHandler() {
    this.$mapElement && this.$mapElement.removeClass('iphone');
  }

  public iPhoneUpdateSizing() {
    setTimeout(() => {
      this.$mapElement = $('#map');

      // handle for iPhone (safari and firefox) only
      let canHandle = !!platform && window.navigator.platform === 'iPhone';
      canHandle = canHandle && platform.product === 'iPhone';
      canHandle = canHandle && (platform.name === 'Safari' || platform.name === 'Firefox');
      canHandle && this.$mapElement && this.$mapElement.addClass('iphone');
    }, 500);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/modal/dialog-map/dialog-map.component.ts